import {EMAIL_PERSONAL_DOMAIN_REGEX} from './workEmail'

export default {
  EMAIL_PERSONAL_DOMAIN_REGEX,
}
